module.exports = __webpack_public_path__ + "img/newInt-cand-screenshot.e1564dc8.svg";